import { SubtasksSectionController } from './subtasks-section.controller'

function subtaskSectionDirective () {
  return {
    restrict: 'E',
    scope: {
      task: '<',
      companyFeatures: '<'
    },
    templateUrl: '/workflow/directives/subtasks-section/subtasks-section-directive.html?$$REVISION$$',
    controller: SubtasksSectionController
  }
}

export { subtaskSectionDirective }
